import { http, IHttpResponse } from './BackendService';
import { authHeader } from '../helpers/auth-header';

export const getAuth = async <T>(
  path: string,
  args: RequestInit = { method: 'get', headers: authHeader() },
): Promise<IHttpResponse<T>> => http<T>(new Request(path, args));

export const postAuth = async <T>(
  path: string,
  body: any,
  args: RequestInit = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(body),
  },
): Promise<IHttpResponse<T>> => http<T>(new Request(path, args));

export const putAuth = async <T>(
  path: string,
  body: any,
  args: RequestInit = {
    method: 'put',
    headers: authHeader(),
    body: JSON.stringify(body),
  },
): Promise<IHttpResponse<T>> => http<T>(new Request(path, args));

export const deleteAuth = async <T>(
  path: string,
  args: RequestInit = {
    method: 'delete',
    headers: authHeader(),
  },
): Promise<IHttpResponse<T>> => http<T>(new Request(path, args));
